import { createFileRoute, redirect } from "@tanstack/react-router";
import { AuthShell } from "@/components/auth/auth-shell";
import { SignupForm } from "@/components/signup-form";
import { useRedirectIfAuthenticated } from "@/lib/auth/hooks";
import { buildLinks, buildMetaTags, getCanonical } from "@/lib/seo/meta";
import { useAuthStore } from "@/stores/auth-store";

export const Route = createFileRoute("/signup")({
	// Redirect authenticated users to dashboard
	// Auth checks are client-side only (no redirects during SSR)
	beforeLoad: ({ search }) => {
		// Skip auth checks during SSR - we have no localStorage on the server
		// The client will handle redirects after hydration
		if (typeof window === "undefined") {
			return;
		}

		const { isAuthenticated } = useAuthStore.getState();

		if (isAuthenticated) {
			// Redirect to the saved redirect path or dashboard
			const redirectTo = (search as { redirect?: string })?.redirect || "/";
			throw redirect({ to: redirectTo });
		}
	},

	head: () => {
		const meta = buildMetaTags({
			title: "Sign Up",
			description: "Create your m8tes.ai account",
			noIndex: true,
			noFollow: true,
		});

		const links = buildLinks({
			canonical: getCanonical("/signup"),
		});

		return { meta, links };
	},

	component: SignupPage,
});

function SignupPage() {
	// Redirect if already authenticated (client-side check for immediate feedback)
	useRedirectIfAuthenticated("/");

	return (
		<AuthShell>
			<SignupForm />
		</AuthShell>
	);
}
